import { createEffectHook } from '../factories/createEffectHook'
import { EventTarget } from '../models/EventTarget'
import { TypedEvent } from '../models/TypedEvent'

import type { TypedNode } from '../models/TypedNode'
import type { ViewModel } from '../models/ViewModel'
import type { Store } from '../stores/Store'

export interface ErrorEventConstructor {
  new (...args: any[]): TypedEvent<Store | TypedNode | ViewModel, Error>
}

/**
 * 错误被修复时触发
 */
export class FixErrorEvent extends TypedEvent<
  Store | TypedNode | ViewModel,
  Error
> {
  type = 'onFixError' as const
}

/**
 * 发生错误时触发
 */
export class RaiseErrorEvent extends TypedEvent<
  Store | TypedNode | ViewModel,
  Error
> {
  type = 'onRaiseError' as const
}

export const { onRaiseError, onRaiseErrorCapture } =
  createEffectHook(RaiseErrorEvent)
export const { onFixError, onFixErrorCapture } = createEffectHook(FixErrorEvent)

export function eventsErrorSideEffect() {
  /**
   * 解决循环依赖，依赖反转
   * events/Error.ts -> factories/createEffectHook.ts -> models/EventTarget.ts -> events/Error.ts
   */
  EventTarget.RaiseErrorEvent = RaiseErrorEvent
  EventTarget.FixErrorEvent = FixErrorEvent
}

eventsErrorSideEffect()

declare global {
  export interface RehajeTypedEvents {
    onFixError: FixErrorEvent
    onRaiseError: RaiseErrorEvent
  }
}
